import React, { useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import {
  addProduct,
  nextPage,
  previousPage,
  removeProduct,
} from "../../redux/onBoardStore";
import axios from "axios";

import ProductList from "../products/ProductList.jsx";
import useProducts from "../../constants/updateProducts";

const OnBoardingForm1 = () => {
  const responseID = window.sessionStorage.getItem("responseID");

  console.log("responseID", responseID);

  const dispatch = useDispatch();
  const [products, setProducts] = useState([]);
  const [style, setStyle] = useState({});

  const [errors, setErrors] = useState({});

  const formValues = useSelector((state) => state.form.formValues.products);

  console.log("formValuesaaaaaa", formValues);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (products.length > 0) {
      // const url = `https://one.lifebanktest.com/v1/marketing/add/${responseID}`;
      const url = `https://one.lifebank.ng/api/v1/marketing/add/${responseID}`;

      // const data = {
      //   formValues,
      // };
      const data = {};

      formValues.forEach((product) => {
        data[product] = product;
      });

      try {
        // const response = await fetch(url, {
        //   method: "POST",
        //   body: JSON.stringify(data),
        //   headers: {
        //     "Content-Type": "application/json",
        //   },
        // });
        console.log("data", data);
        const response = await axios.post(url, data);

        console.log("responseforproduct", response);

        // if (!response.ok) {
        //   throw new Error("Network response was not ok");
        // }

        // const jsonData = await response.json();
        // console.log(jsonData);
        dispatch(nextPage());
      } catch (error) {
        console.error("There was a problem with the fetch operation:", error);
      }
      // dispatch(nextPage());
    } else {
      setErrors({ products: "Required" });
    }
  };
  const handleProductClick = (name, style) => {
    const productIndex = products.indexOf(name);
    if (productIndex >= 0) {
      setProducts(products.filter((item) => item !== name));
      dispatch(removeProduct(name));
    } else {
      setProducts([...products, name]);
      dispatch(addProduct(name));
    }
    const updatedStyle = {
      ...style,
      border: productIndex >= 0 ? "none" : "4px solid #B70303",
      borderRadius: "5px",
    };
    setStyle(updatedStyle);
    if (errors.products) {
      setErrors({ ...errors, products: "" });
    }
  };

  return (
    <form className="mt-6 md:mt-8 lg:mt-3 ">
      <div className="grid lg:grid-cols-2  gap-4">
        <ProductList
          products={useProducts}
          selectedProducts={products}
          onClick={handleProductClick}
          style={style}
        />
      </div>

      <div className="flex mt-8 flex-col lg:flex-row gap-6 md:justify-center lg:justify-end justify-center">
        <button
          className="btn-save"
          onClick={(e) => {
            e.preventDefault();
            dispatch(previousPage());
          }}
        >
          Previous
        </button>
        <button type="submit" className="btn" onClick={handleSubmit}>
          Next {">"}
        </button>
      </div>
    </form>
  );
};

export default OnBoardingForm1;
